<template>
	<div class="goal-card-skeleton">
		<div class="goal-card-skeleton__sub-group">
			<div class="goal-card-skeleton__title">
				<Skeleton />
			</div>
			<div class="goal-card-skeleton__date">
				<Skeleton />
			</div>
		</div>
		<div class="goal-card-skeleton__sub-group">
			<div class="goal-card-skeleton__details">
				<div class="goal-card-skeleton__detail-cell">
					<div class="goal-card-skeleton__detail-header"><Skeleton /></div>
					<div class="goal-card-skeleton__detail-value"><Skeleton /></div>
				</div>
				<div class="goal-card-skeleton__detail-cell">
					<div class="goal-card-skeleton__detail-header"><Skeleton /></div>
					<div class="goal-card-skeleton__detail-value"><Skeleton /></div>
				</div>
				<div class="goal-card-skeleton__detail-cell">
					<div class="goal-card-skeleton__detail-header"><Skeleton /></div>
					<div class="goal-card-skeleton__detail-value"><Skeleton /></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Skeleton from "primevue/skeleton";
export default {
	name: "GoalCardSkeleton",
	components: {
		Skeleton,
	},
};
</script>

<style lang="scss" scoped>
$goalCardSkeletonBorderColor: $color1-200;

.goal-card-skeleton {
	padding: 1rem;
	border: 0.0625rem solid $goalCardSkeletonBorderColor;
	border-radius: .5rem;

	@include for-size('xs') {
		display: block;
		max-height: 9.25rem;
	}

	@include for-size('sm') {
		display: block;
		max-height: 9.25rem;
	}

	@include for-size('md') {
		display: flex;
		padding-bottom: 0;
		max-height: 5.25rem;
	}

	@include for-size('lg') {
		display: flex;
		padding-bottom: 0;
		max-height: 5.25rem;
	}

	@include for-size('xl') {
		display: flex;
		padding-bottom: 0;
		max-height: 5.25rem;
	}
}

.goal-card-skeleton__sub-group {
	@include for-size('xs') {
		width: 100%;
	}

	@include for-size('sm') {
		width: 100%;
	}

	@include for-size('md') {
		width: 50%;
	}

	@include for-size('lg') {
		width: 50%;
	}

	@include for-size('xl') {
		width: 50%;
	}
}

.goal-card-skeleton__title {
	text-align: left;
	width: 100%;
	margin-bottom: .75rem;
}

.goal-card-skeleton__date {
	text-align: left;
	width: 30%;
	margin-bottom: 1.5rem;
}

.goal-card-skeleton__details {
	display: flex;

	@include for-size('md') {
		justify-content: space-between;
		margin-left: 1rem;
	}

	@include for-size('lg') {
		justify-content: space-between;
		margin-left: 1rem;
	}

	@include for-size('xl') {
		justify-content: space-between;
		margin-left: 1rem;
	}
}

.goal-card-skeleton__detail-cell {
	width: 30%;
}

.goal-card-skeleton__detail-header {
	margin-bottom: .75rem;
	margin-right: 1.5rem;

	@include for-size('md') {
		margin-right: 0;
	}

	@include for-size('lg') {
		margin-right: 0;
	}

	@include for-size('xl') {
		margin-right: 0;
	}
}

.goal-card-skeleton__detail-value {
	width: 48%;
}

</style>
